import { motion } from "framer-motion";
import React from "react";

const EASE = [0.76, 0, 0.24, 1];

// A kinetic masked reveal for a single line of text.
export function MaskLine({ children, delay = 0, duration = 1.1, className = "", as = "span" }) {
  const Wrapper = motion[as] || motion.span;
  return (
    <span className="kinetic-mask">
      <Wrapper
        className={`kinetic-line ${className}`}
        initial={{ y: "110%" }}
        animate={{ y: "0%" }}
        transition={{ duration, delay, ease: EASE }}
      >
        {children}
      </Wrapper>
    </span>
  );
}

// Fade + subtle rise on scroll into view
export function Rise({ children, delay = 0, y = 40, duration = 0.9, className = "", once = true }) {
  return (
    <motion.div
      className={className}
      initial={{ opacity: 0, y }}
      whileInView={{ opacity: 1, y: 0 }}
      viewport={{ once, margin: "-80px" }}
      transition={{ duration, delay, ease: EASE }}
    >
      {children}
    </motion.div>
  );
}

export const EASE_CURVE = EASE;
